import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MaxDurationShareButton from 'blocks/DownloadPage/components/MaxDurationShareButton';
import { ThreadsButton } from 'components/SocialButton';
import useThreadsAuthenticator from 'hooks/useThreadsAuthenticator';
import { videoDurationSecondsSelector } from 'redux/modules/download';
import { hideModal, pushModal } from 'redux/modules/modal';
import { createChainedFunction } from 'utils/functions';
import { formatDurationInFull } from 'utils/time';
import useOnDownloadPageAction from '../useOnDownloadPageAction';
import { MAX_VIDEO_DURATION_SEC } from './utils';

const ThreadsPostButton: React.FC = () => {
  const [shouldReauthenticate, setShouldReauthenticate] = useState<boolean>(
    false,
  );

  const videoDurationSec = useSelector(videoDurationSecondsSelector);

  const { onDownloadPageAction } = useOnDownloadPageAction();
  const dispatch = useDispatch();

  const handleError = useCallback(() => {
    setShouldReauthenticate(true);
    dispatch(hideModal());
  }, [dispatch]);

  const { authenticating, withAuthentication } = useThreadsAuthenticator({
    force: shouldReauthenticate,
    onError: handleError,
  });

  const openSocialShareModal = useCallback(() => {
    dispatch(
      pushModal({
        name: 'SocialShare',
        params: {
          platform: 'threads',
        },
      }),
    );
  }, [dispatch]);

  return (
    <MaxDurationShareButton
      platform="threads"
      videoDurationSec={videoDurationSec}
      maxVideoDurationSec={MAX_VIDEO_DURATION_SEC}
      tooltTipContent={`Threads only allows videos ${formatDurationInFull(
        MAX_VIDEO_DURATION_SEC * 1000,
      )} min or less`}
    >
      <ThreadsButton
        size="small"
        params={withAuthentication}
        disabled={authenticating}
        onClick={createChainedFunction(
          () => onDownloadPageAction('threadsShare'),
          withAuthentication(openSocialShareModal),
        )}
      />
    </MaxDurationShareButton>
  );
};

export default ThreadsPostButton;
